import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route } from "react-router-dom";

//project imports
import App from './App';
import Notifications from './views/notifications/view-notifications';
import Archer from './views/archer/view-archer';
import NonfilerTracker from './views/nonfilerTracker/view-nonfiler-tracker';
import NotFound from './static/NotFound';
import reportWebVitals from './reportWebVitals';
import FineTracker from './views/fineTracker/view-fine-tracker';
import MailTracker from './views/mailTracker/view-mail-tracker';
import ItDashboard from './views/itDashboard/view-it-dashboard';
import ItDashboard2 from './views/itDashboard/view-it-dashboard2';
import SignInTracker from './views/signInTracker/view-sign-in-tracker';
import OcpfWatchSubscribers from './views/ocpfWatch/view-ocpf-watch-subscribers';
import AttorneyOfTheDay from './views/attorneyOfTheDay/view-attorney-of-the-day';
import FormManager from './views/formManager/view-form-manager';
import TestForm from './views/formManager/view-form-test';
import Supplies from './views/supplies/view-supplies';
import Knowledge from './views/knowledge/view-knowledge';
import LegalLetters from './views/legalLetters/view-legal-letters';

// ==============================|| REACT DOM RENDER  ||============================== //
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <Routes>
            <Route path="/apps" element={<App />} />
            <Route path="/apps/notifications" element={<Notifications />} />
            <Route path="/apps/archer" element={<Archer />} />
            <Route path="/apps/nonfilertracker" element={<NonfilerTracker />} />
            <Route path="/apps/fineTracker" element={<FineTracker />} />
            <Route path="/apps/mailTracker" element={<MailTracker />} />
            <Route path="/apps/signInTracker" element={<SignInTracker />} />
            <Route path="/apps/ocpfWatch" element={<OcpfWatchSubscribers />} />
            <Route path="/apps/aod" element={<AttorneyOfTheDay />} />
            <Route path="/apps/forms" element={<FormManager />} />
            <Route path="/apps/testForms" element={<TestForm />} />
            <Route path="/apps/itDashboard" element={<ItDashboard />} />
            <Route path="/apps/itDashboard2" element={<ItDashboard2 />} />
            <Route path="/apps/supplies" element={<Supplies />} />
            <Route path="/apps/knowledge/*" element={<Knowledge />} />
            <Route path="/apps/legalLetters" element={<LegalLetters />} />
            <Route path='*' element={<NotFound />} />
        </Routes>
    </BrowserRouter>

);


//maybe: to be removed

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
